import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @author Cristian Ciro
 * @version jdesk_1.01.0002
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomSaldosWoocommerce extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.abrirTbPrincipal           = this.abrirTbPrincipal.bind(this);
        this.successMostrarTbPrincipal  = this.successMostrarTbPrincipal.bind(this);
        this.onSelectionChangedRowTableMov = this.onSelectionChangedRowTableMov.bind(this);

        this.gridOptionsTbPrincipal     = Object.assign({},this.gridOptions);
        this.gridOptionsTbPrincipal.onSelectionChanged = this.onSelectionChangedRowTableMov;

        this.setButtonIgualar           = this.setButtonIgualar.bind(this);
        this.setCantidad                = this.setCantidad.bind(this);
        this.onBtNext2                  = this.onBtNext2.bind(this);
        this.onBtPrevius2               = this.onBtPrevius2.bind(this);
        this.onKeyUpText                = this.onKeyUpText.bind(this);
        this.igualarCantidad            = this.igualarCantidad.bind(this);
        this.successActualizarCantidad  = this.successActualizarCantidad.bind(this);
        this.igualarSaldosLekamp        = this.igualarSaldosLekamp.bind(this);
        this.mostrarMensajeGenerando    = this.mostrarMensajeGenerando.bind(this);

        this.limpiarCampos              = this.limpiarCampos.bind(this);

        this.arrayItems                 = [];

    }

    onBtNext2(){
        this.getField("consultar_pagina").setValue(parseInt(this.getField("consultar_pagina").getValue())+1);
        this.abrirTbPrincipal();
    }

    onBtPrevius2(){
        this.getField("consultar_pagina").setValue(parseInt(this.getField("consultar_pagina").getValue())-1);
        this.abrirTbPrincipal();
    }

    onKeyUpText(value){
        this.getField("consultar_pagina").setValue(value);
        this.abrirTbPrincipal();
    }

    initForm(){
        console.log('Formulario CustomSaldosWoocommerce,  @version: jdesk_1.01.0002, @author:Cristian Ciro');
        
        this.getField("seleccion_text").setValue(0);
        //this.abrirTbPrincipal();
        //this.getField("bt_igualar").setLabel("Igualar (0)");

        this.getField("select_bodegas").setOnChange(() => {
            this.limpiarCampos();
        });
        this.getField("bt_igualar").setDisabled(true);
        this.getField("bt_igualar").setClick(() => {
            if(this.getField("seleccion_text").valid()){
                this.mostrarMensajeGenerando();
                this.igualarSaldosLekamp();
            }
        });

        this.getField("bt_consultar_productos").setClick(() => {
            this.abrirTbPrincipal();
        });
    } 

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está actualizando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    limpiarCampos(){
        this.getField("tabla_saldos_lekamp").toggle(false);
        this.getField("seleccion_text").setVisible(false);
        this.getField("seleccion_text").setValue(0);
        this.getField("bt_igualar").setVisible(false);
        this.getField("bt_igualar").setDisabled(true);
    }

    abrirTbPrincipal(){
        if(this.getField("select_bodegas").valid()){
            this.limpiarCampos();
            this.getField("bt_consultar_productos").setDisabled(true);
            this.getField("select_bodegas").setDisabled(true);
            let datos = { datos: {
                page: "1",
                bodega:this.getField("select_bodegas").getValue()
            }};
            this.generalFormatPmv = { tipo_servicio: 'int-saldoswoocommerce', operacion: '2_1', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successMostrarTbPrincipal,
                error: this.error_,
                general: this.generalFormatPmv
            });
        }
    }

    successMostrarTbPrincipal(data){
        this.getField("bt_consultar_productos").setDisabled(false);
        this.getField("select_bodegas").setDisabled(false);
        this.getField("seleccion_text").setVisible(true);
        this.getField("seleccion_text").setValue(0);
        this.getField("bt_igualar").setVisible(true);
        if(data.estado_p === 200){
            this.gridOptionsTbPrincipal.paginationPageSize = 10;
            this.gridOptionsTbPrincipal['rowData'] = data.data;
            let configCell = new Map();

            configCell.set('cantidad_jaivana',{cellRenderer:function(props){return''.formatoPrecio(props.data.cantidad_jaivana!== undefined ?props.data.cantidad_jaivana.toFixed(2):0.00)},type: 'rightAligned',field:'cantidad_jaivana'});
            configCell.set('cantidad',{cellRenderer: this.setCantidad, type: 'rightAligned',field:'cantidad'});
            configCell.set('seleccion', {headerCheckboxSelection: true,headerCheckboxSelectionFilteredOnly: true,checkboxSelection: function(props){return props.data.cantidad > props.data.cantidad_jaivana || props.data.cantidad < props.data.cantidad_jaivana}, sortable: false, filter: false,field: "seleccionar",});
            configCell.set('accion', { cellRenderer: this.setButtonIgualar, width: 110, sortable: false, filter: false, field: 'accion' });
            
            this.gridOptionsTbPrincipal["suppressRowClickSelection"] = true;
            this.gridOptionsTbPrincipal["rowSelection"] = "multiple";
            this.gridOptionsTbPrincipal["enableRangeSelection"] = true;
            this.gridOptionsTbPrincipal.enableCellTextSelection = true;

            this.getField('tabla_saldos_lekamp').initData(this.gridOptionsTbPrincipal,configCell);
            
        }else{
            
        }
    }

    selectAllRenderer(params) {
        var cb = document.createElement('input');
        cb.setAttribute('type', 'checkbox');

        var eHeader = document.createElement('label');
        var eTitle = document.createTextNode(params.colDef.headerName);
        eHeader.appendChild(cb);
        eHeader.appendChild(eTitle);

        cb.addEventListener('change', function (e) {
            if ((this)[0].checked) {
                params.api.selectAll();
            } else {
                params.api.deselectAll();
            } 
        });
        return this.createElementJaivana(eHeader); 
    }

    onSelectionChangedRowTableMov(){
        this.arrayItems = [];
        this.getField("bt_igualar").setDisabled(true);
        this.getField("bt_igualar").setDisabled(false);
        this.gridOptionsTbPrincipal.api.forEachNode(node => {
            if(node.selected && (node.data['cantidad'] !== node.data['cantidad_jaivana'])){
                this.arrayItems.push(node.data);
            }
        });
        this.getField("seleccion_text").setValue(this.arrayItems.length);
        if(this.arrayItems.length === 0)
            this.getField("bt_igualar").setDisabled(true);
        else{
            this.getField("bt_igualar").setDisabled(false);
        }
    }

    setCantidad(props){
        let id = props.data.id;
        let div = document.createElement("div");
        if(props.data.cantidad < props.data.cantidad_jaivana || props.data.cantidad > props.data.cantidad_jaivana)
            div.setAttribute("class", "labelRed");
        //button.onclick = ()=>{this.integrarPedido(props.data);};
        
        div.setAttribute("id", 'div_igualar_' + id);
        div.setAttribute("value", ''.formatoPrecio(props.data.cantidad!== undefined ?props.data.cantidad.toFixed(2):0.00));
        return this.createElementJaivana(div);
    }

    setButtonIgualar(props){
        let id = props.data.id;
        let button = document.createElement("input");
        if(props.data.cantidad < props.data.cantidad_jaivana || props.data.cantidad > props.data.cantidad_jaivana){
            button.setAttribute("class", "buttonStyle");
            button.onclick = ()=>{this.igualarCantidad(props.data);};
        }else
            button.setAttribute("class", "buttonDisabled");
        //button.onclick = ()=>{this.integrarPedido(props.data);};
        
        button.setAttribute("id", 'button_igualar_' + id);
        button.setAttribute("type", "button");
        button.setAttribute("value", "Igualar");
        return this.createElementJaivana(button);
    }

    igualarCantidad(data){
        this.arrayItems = [];
        this.arrayItems.push(data);
        this.igualarSaldosLekamp();
    }

    igualarSaldosLekamp(){
        if(this.arrayItems.length > 100){
            console.log("Error 100");
        }else{
            let datos = { datos: {
                items: this.arrayItems
            }};
            this.generalFormatPmv = { tipo_servicio: 'int-saldoswoocommerce', operacion: '5_2', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successActualizarCantidad,
                error: this.error_,
                general: this.generalFormatPmv
            });
        }
    }

    successActualizarCantidad(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.limpiarCampos();
            this.getField('tabla_saldos_lekamp').toggle(false);
            this.abrirTbPrincipal();
        }
    }

}

FormJaivana.addController("int-saldoswoocommerce",CustomSaldosWoocommerce);
export default CustomSaldosWoocommerce